export const ProgressPanel = ({ kit }) => {
  const p = kit.progress || {};
  const pct = p.total ? Math.min(99, Math.round((p.done / p.total) * 100)) : 3;
  const failed = kit.status === "failed";
  return (
    <div data-testid="generation-progress" className="rounded-xl border border-stone-200 bg-white p-6 mb-8 rise">
      <div className="flex justify-between items-baseline">
        <div>
          <div className="eyebrow">{failed ? "Generation stopped" : "Research desk"}</div>
          <div className="font-display text-2xl text-[#2B2A26] mt-1" data-testid="progress-current">{failed ? "Something went wrong" : p.current}</div>
        </div>
        {!failed && <div className="font-mono-ui text-3xl text-[#9A7B2C]" data-testid="progress-percent">{pct}%</div>}
      </div>
      {!failed && (
        <div className="mt-5 h-2 rounded-sm bg-stone-100 overflow-hidden relative">
          <div className="h-full bg-[#C9A847] transition-[width] duration-700" style={{ width: `${pct}%` }} />
          <div className="absolute inset-0 shimmer" />
        </div>
      )}
      {kit.error && <div data-testid="generation-error" className="mt-4 text-sm text-red-400 break-words">{kit.error}</div>}
      {kit.log?.length > 0 && (
        <div className="mt-5 font-mono-ui text-xs text-stone-500 space-y-1 max-h-40 overflow-auto">
          {kit.log.slice(-12).map((l, i) => <div key={i}>{l}</div>)}
        </div>
      )}
      {!failed && <p className="text-xs text-stone-500 mt-4">Sections are researched in parallel. Typical time: 6–10 minutes for a Mini-Break, up to 20 minutes for Elite.</p>}
    </div>
  );
};
